import { Service } from '@roc/feature-app-core';

export abstract class AppraisalReviewBaseService extends Service {

  abstract getLoanDetails(loanId: number);
  abstract getAmcById(amcId: number);
  abstract getAutomatedAppraisalReviewReport(propertyId: number, loanId: number);
  abstract saveReview(propertyId: number, loanId: number, data: any);
  abstract downloadRevisionListPdf(propertyId: number, data: any);
  abstract approveReport(propertyId: number, loanId: number, valuationType?: string);
  abstract getLoanPropertyValuations(loanId: number, propertyId: number);
  abstract requestAppraisal1004D(propertyId: number, loanId: number);
  abstract createResolutionPerItem(data: any);
  abstract requestRevision(data: any);
  abstract getAllAppraiserFirmNames();
  abstract getAutomatedManualFlag(loanId: number, propertyId: number);
  abstract getReportEditableFlag(loanId: number, propertyId: number);
  abstract updateReportEditableFlag(loanId: number, propertyId: number, editable: boolean);
  abstract updateUwAppraisalReviewStatus(loanId: number, propertyId: number, status: string);
  abstract getAppraisalReviewItemNames();
  abstract getAutomatedAppraisalReviewPhotos(propertyId: number, loanId: number);
  abstract getAppraisalReviewVersion(propertyId: number, loanId: number);
  abstract getAutomatedManualFlagByLoanId(loanId: number);
  abstract getShouldShowSecondaryValuationFields(loanId: number, propertyId: number);
  abstract getAppraisalReportStatus(loanId: number, propertyId: number);
}